import $P from 'plugins/kapida/platformConfigs/integrationMaps/transferOrderDetail';
import { objectSelector } from 'theme/utils';

class TransferOrder {
  constructor(item) {
    const {
      id,
      number,
      order,
      orderNumber,
      channelName,
      commands,
      customerName,
      customerSurname,
      source,
      destination,
      state,
      shippingAddress,
      transferItemSet,
      transferTargetDate,
    } = item;
    this.id = id;
    this.number = number;
    this.order = order;
    this.orderNumber = orderNumber;
    this.channelName = channelName;
    this.commands = commands;
    this.customerName = customerName;
    this.customerSurname = customerSurname;
    this.source = source;
    this.destination = destination;
    this.state = state;
    this.shippingAddress = shippingAddress;
    this.transferItemSet = transferItemSet;
    this.transferTargetDate = transferTargetDate;
  }
}

// eslint-disable-next-line no-unused-vars
class TransferItem {
  constructor(item) {
    const { name, state, product } = item;
    this.name = name;
    this.state = state;
    this.product = product;
  }
}

class Product {
  constructor(item) {
    const { id, image, name, sku } = item;
    this.id = id;
    this.image = image;
    this.name = name;
    this.sku = sku;
  }
}

class ShippingAddress {
  constructor(item) {
    const { title, line, city } = item;
    this.title = title;
    this.line = line;
    this.city = city;
  }
}

const shippingAddressMapper = (item) => {
  return new ShippingAddress({
    title: objectSelector(item, $P.SHIPPING_ADDRESS.TITLE),
    line: objectSelector(item, $P.SHIPPING_ADDRESS.LINE),
    city: objectSelector(item, $P.SHIPPING_ADDRESS.CITY),
  });
};

// eslint-disable-next-line no-unused-vars
const productMapper = (item) => {
  const { PRODUCT } = $P.TRANSFER_ITEM;
  return new Product({
    id: objectSelector(item, PRODUCT.ID),
    image: objectSelector(item, PRODUCT.IMAGE),
    name: objectSelector(item, PRODUCT.NAME),
    sku: objectSelector(item, PRODUCT.SKU),
  });
};

const transferItemsMapper = (transferItems) => {
  return transferItems;
};

export const transferOrderDetailMapper = (item) => {
  const transferOrder = new TransferOrder({
    id: objectSelector(item, $P.ID),
    number: objectSelector(item, $P.NUMBER),
    order: objectSelector(item, $P.ORDER),
    orderNumber: objectSelector(item, $P.ORDER_NUMBER),
    channelName: objectSelector(item, $P.CHANNEL_NAME),
    commands: objectSelector(item, $P.COMMANDS),
    customerName: objectSelector(item, $P.CUSTOMER_NAME),
    customerSurname: objectSelector(item, $P.CUSTOMER_SURNAME),
    source: objectSelector(item, $P.SOURCE),
    destination: objectSelector(item, $P.DESTINATION),
    state: objectSelector(item, $P.STATE),
    shippingAddress: shippingAddressMapper(
      objectSelector(item, $P.SHIPPING_ADDRESS_PATH)
    ),
    transferItemSet: transferItemsMapper(
      objectSelector(item, $P.TRANSFER_ITEM_SET_PATH, [])
    ),
    transferTargetDate: objectSelector(item, $P.TRANSFER_TARGET_DATE),
  });
  return transferOrder;
};



// WEBPACK FOOTER //
// ./src/models/kapidaModels/transferOrderDetail.js